import React from "react";

export default function Calendar() {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9219 4.625C12.0859 4.625 12.25 4.48828 12.25 4.29688V3.3125C12.25 2.60156 11.6484 2 10.9375 2H9.625V0.578125C9.625 0.414062 9.46094 0.25 9.29688 0.25H8.20312C8.01172 0.25 7.875 0.414062 7.875 0.578125V2H4.375V0.578125C4.375 0.414062 4.21094 0.25 4.04688 0.25H2.95312C2.76172 0.25 2.625 0.414062 2.625 0.578125V2H1.3125C0.574219 2 0 2.60156 0 3.3125V4.29688C0 4.48828 0.136719 4.625 0.328125 4.625H11.9219ZM0.328125 5.5C0.136719 5.5 0 5.66406 0 5.82812V12.9375C0 13.6758 0.574219 14.25 1.3125 14.25H10.9375C11.6484 14.25 12.25 13.6758 12.25 12.9375V5.82812C12.25 5.66406 12.0859 5.5 11.9219 5.5H0.328125ZM9.43359 8.125C9.54297 8.26172 9.54297 8.48047 9.43359 8.58984L5.52344 12.4727C5.38672 12.6094 5.16797 12.6094 5.05859 12.4727L2.78906 10.2031C2.67969 10.0664 2.67969 9.875 2.78906 9.73828L3.58203 8.97266C3.69141 8.83594 3.91016 8.83594 4.04688 8.97266L5.30469 10.2305L8.20312 7.35938C8.3125 7.22266 8.53125 7.22266 8.66797 7.35938L9.43359 8.125Z"
        fill="currentColor"
      />
    </svg>
  );
}
